(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.announcementBar = document.querySelector('.announcement-bar');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 1024px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      //console.log('setHeaderHeight', this.header.offsetHeight);
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      if (this.announcementBar) {
        document.documentElement.style.setProperty(
          '--header-height-full',
          `${this.announcementBar.offsetHeight + this.header.offsetHeight}px`
        );
      } else {
        document.documentElement.style.setProperty('--header-height-full', `${this.header.offsetHeight}px`);
      }
      //document.documentElement.style.setProperty('--header-height', `123px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      //console.log('reveal menu');
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      //console.log('reset menu');
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  function isMobileCheck() {
    const mobileDisplay = getComputedStyle(document.querySelector('header-drawer')).display;
    return mobileDisplay !== 'none';
  }

  function closeNav() {
    document.querySelector('.header-bottom').classList.remove('active');
    document.querySelectorAll('.header-bottom__item.has-dropdown.active').forEach((item) => {
      item.classList.remove('active');
    });
    document.querySelector('.header-bottom .dropdown-bg').style.height = '0';
  }

  document.addEventListener('DOMContentLoaded', function () {
    const dropdownCheck = document.querySelectorAll('.header-bottom__item.has-dropdown').length;
    //console.log('dropdownCheck', dropdownCheck);

    document.querySelectorAll('.header-bottom__item.has-dropdown').forEach((item) => {
      item.addEventListener('mouseover', function () {
        if (!isMobileCheck()) {
          document.querySelectorAll('.header-bottom__item.has-dropdown.active').forEach((activeItem) => {
            activeItem.classList.remove('active');
          });
          this.classList.add('active');
          const dropdown = this.querySelector('.header-bottom__submenu');
          const height = dropdown.offsetHeight;
          //console.log('height: ' + height);
          document.querySelector('.header-bottom').classList.add('active');
          document.querySelector('.header-bottom .dropdown-bg').style.height = height + 'px';
        }
      });
    });

    document.querySelectorAll('.header-bottom__item:not(.has-dropdown) > a').forEach((link) => {
      link.addEventListener('mouseover', function () {
        if (!isMobileCheck()) {
          closeNav();
        }
      });
    });

    document.querySelector('.header-bottom').addEventListener('mouseleave', function () {
      if (!isMobileCheck()) {
        closeNav();
      }
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelector('.header-top').classList.add('loaded');
    document.querySelector('.header-bottom').classList.add('loaded');
  });

  } catch(e) { console.error(e); }
})();
})();
